import React from 'react'
import NominalGDPPerCapitaChart from './NominalGDPPerCapitaChart'

export default function NominalGDPPerCapita() {
  return (
    <>
      <NominalGDPPerCapitaChart />
    </>
  )
}
